export default __webpack_public_path__ + "static/media/ahanaf.b3446e17.jpg";